import React, { FunctionComponent } from "react";
import { Spinner } from "../Spinner";

export type ItemProps = {
  klass: string;
  label: string;
  value: string | number;
};

type OrderSummaryProps = {
  title: string;
  description: string;
  items: Array<ItemProps>;
  showFooter: boolean;
  loading: boolean;
};

export const OrderSummary: FunctionComponent<OrderSummaryProps> = ({
  title,
  description,
  items,
  showFooter,
  loading,
}) => {
  const renderLineItem = (klass: string, label: string, value: string | number) => (
    <div key={klass} className={`line ${klass}`}>
      <label>{label}</label>
      <span>{value}</span>
    </div>
  );

  const renderItems = (items: Array<ItemProps>) => (
    <div>
      {items.map((item) => {
        return renderLineItem(item.klass, item.label, item.value);
      })}
    </div>
  );

  return (
    <div className="order-summary">
      <h3>{title}</h3>
      <h4>{description}</h4>
      {loading && (
        <div style={{ height: "278px" }}>
          <Spinner />
        </div>
      )}
      {!loading && renderItems(items)}
      {showFooter && (
        <p className="disclaimer">
          By clicking “Complete Order”, you accept our{" "}
          <a
            href="https://www.ownlocal.com/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            terms
          </a>
          {" "} and we'll charge your credit card immediately.
        </p>
      )}
    </div>
  );
};

export default OrderSummary;
